import {
  TOGGLE_FORM,
  DISMISS_FORM,
  TOGGLE_REPORT,
  DISMISS_REPORT,
  TOGGLE_SHIPMENT_ATTACHMENT,
  DISMISS_SHIPMENT_ATTACHMENT,
  TOGGLE_ORDER_ATTACHMENT,
  DISMISS_ORDER_ATTACHMENT,
  TOGGLE_SHIPMENT_STATUS,
  DISMISS_SHIPMENT_STATUS,
  TOGGLE_ARCHIVED_SHIPMENTS,
  TOGGLE_PLANNED_ORDERS,
  SWITCH_TABLE_COMPONENT,
} from "../actions/ui_actions";

const uiReducer = (
  state = {
    formName: "",
    reportName: '',
    reportItems: [],
    shipmentAttachment: false,
    orderAttachment: false,
    shipmentStatus: false,
    isArchivedShipmentsVisible: false,
    isPlannedOrdersVisble: false,
    visibleTableComponent: '',
    
  },
  action
) => {
  switch (action.type) {
    case TOGGLE_FORM:
      return {
        ...state,
        formName: action.formName,
        addOrEdit: action.addOrEdit
      };

    case DISMISS_FORM:
      return {
        ...state,
        formName: "",
        addOrEdit: ""
      };

      case TOGGLE_REPORT:
      return {
        ...state,
        reportName: action.reportName,
        reportItems: action.reportItems
      };

    case DISMISS_REPORT:
      return {
        ...state,
        reportName: "",
        reportItems: []
      };

    case TOGGLE_SHIPMENT_ATTACHMENT:
      return {
        ...state,
        shipmentAttachment: true
      };
    case DISMISS_SHIPMENT_ATTACHMENT:
      return {
        ...state,
        shipmentAttachment: false
      };
    case TOGGLE_ORDER_ATTACHMENT:
      return {
        ...state,
        orderAttachment: true
      };
    case DISMISS_ORDER_ATTACHMENT:
      return {
        ...state,
        orderAttachment: false
      };
    case TOGGLE_SHIPMENT_STATUS:
      return {
        ...state,
        shipmentStatus: !state.shipmentStatus
      };
    case DISMISS_SHIPMENT_STATUS:
      return {
        ...state,
        shipmentStatus: false
      };
    case TOGGLE_ARCHIVED_SHIPMENTS:
      return {
        ...state,
        isArchivedShipmentsVisible: !state.isArchivedShipmentsVisible
      };
    case TOGGLE_PLANNED_ORDERS:
      return {
        ...state,
        isPlannedOrdersVisble: !state.isPlannedOrdersVisble
      };
    case SWITCH_TABLE_COMPONENT:
      return {
        ...state,
        visibleTableComponent: action.component
      };

    default:
      return state;
  }
};

export default uiReducer;



// WEBPACK FOOTER //
// ./src/reducers/ui_reducer.js